export default "__VITE_ASSET__BjppIDz2__"